"use client";

import { createContext, useContext } from "react";
import type { Density, ThemeMode } from "./types";

export interface ThemeContextValue {
  theme: ThemeMode;
  density: Density;
}

export const ThemeContext = createContext<ThemeContextValue>({
  theme: "light",
  density: "comfortable",
});

export function useTheme(): ThemeMode {
  return useContext(ThemeContext).theme;
}

// Components call useDensity(props.density) so an explicit prop always wins
// over the ambient context, per the density override rule.
export function useDensity(override?: Density): Density {
  const { density } = useContext(ThemeContext);
  return override ?? density;
}
